import { useEffect, useState } from "react";
import CongCuIcon from "./CongCuIcon.jsx";

/**
 * Khung xanh đầu trang /cong-cu, cùng kiểu với "kệ sách" Playbook và biểu đồ
 * Nguồn vốn: vẽ từ danh sách công cụ thật. Mỗi cột là một trạm, mỗi ô vuông
 * có biểu tượng là một công cụ, màu theo trạm (trùng màu biểu tượng trên thẻ).
 * Chạm một cột là lọc công cụ của trạm đó (onChon), chạm lại thì bỏ lọc.
 */
export default function CongCuBanDo({ nhom, dangChon, onChon }) {
  const [hien, setHien] = useState(true);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return undefined;
    setHien(false);
    const id = requestAnimationFrame(() => requestAnimationFrame(() => setHien(true)));
    return () => cancelAnimationFrame(id);
  }, []);

  const tong = nhom.reduce((a, n) => a + n.ds.length, 0);
  const tongPhut = nhom.reduce((a, n) => a + n.ds.reduce((b, t) => b + (t.minutes || 0), 0), 0);
  const soTram = nhom.filter((n) => n.so).length;

  return (
    <div className={"ccb" + (hien ? " hien" : "")}>
      <div className="ccb-dau">
        <span>{tong} công cụ theo {soTram} trạm</span>
        <span className="ccb-goi-y">Chạm để lọc</span>
      </div>
      <div className="ccb-cot" role="group" aria-label="Lọc công cụ theo trạm">
        {nhom.map((n, ci) => (
          <button
            key={n.id}
            type="button"
            className={dangChon === n.id ? "dang" : dangChon ? "mo" : ""}
            aria-pressed={dangChon === n.id}
            disabled={!n.ds.length}
            onClick={() => onChon(dangChon === n.id ? "" : n.id)}
            aria-label={`${n.so ? `Trạm ${n.so}: ` : ""}${n.ten}, ${n.ds.length} công cụ`}
            style={{ "--mau": n.mau }}
          >
            <span className="ccb-o" aria-hidden="true">
              {n.ds.map((t, i) => (
                <i key={t.slug} style={{ "--d": `${ci * 80 + i * 60}ms` }}>
                  <CongCuIcon slug={t.slug} />
                </i>
              ))}
            </span>
            <span className="ccb-ten">
              <b>{n.so ? `Trạm ${n.so}` : "Bắt đầu"}</b>
              <small className="ccb-ten-dai">{n.ten}</small>
              <small>{n.ds.length} công cụ</small>
            </span>
          </button>
        ))}
      </div>
      <p className="ccb-chan">
        <b>{tong}</b> công cụ, khoảng <b>{tongPhut}</b> phút nếu làm hết, không cần tài khoản
      </p>
    </div>
  );
}
